import { css } from '@linaria/core';
import { styled } from '@linaria/react';
import { motion } from 'framer-motion';

export const overlayStyle = css`
	position: fixed;
	z-index: 100;
	bottom: var(--keyboard-height, 0);
	left: 0;
	display: flex;
	width: 100%;
	height: 100%;
	contain: paint;
`;

export const backdropStyle = css`
	backdrop-filter: blur(10px);
	background-color: var(--color-black-l);
`;

export const BaseVisibilityWrapper = styled(motion.div)`
	outline: none;
	&.fullpage {
		backdrop-filter: none;
	}
	&:has(~ .fullpage) {
		content-visibility: hidden;
	}
`;

export const BaseFullContainer = styled.div`
	position: relative;
	z-index: 0;
	display: flex;
	width: 100vw;
	height: 100%;
	min-height: 0;
	flex-flow: column nowrap;
	align-items: center;
	justify-content: flex-start;
	background: var(--main-bg);
	color: var(--color-white-solid);
	contain: paint;
	overflow-x: hidden;
	overflow-y: auto;
`;
